import React from "react";
import { Link } from "react-router-dom";
import portrait from "../Images/images/demo-professional.png";
import "./Scheduledemo.css";

const benefits = [
  "Faster HR Operations",
  "Happier Employees",
  "Higher Productivity",
];

const ScheduleDemo = () => (
  <section className="schedule-demo" aria-labelledby="schedule-demo-title">
    <div className="schedule-demo__inner">
      <div className="schedule-demo__copy">
        <h2 id="schedule-demo-title">Ready to Simplify Your HR Operations?</h2>
        <p>
          Join 200+ businesses that trust BillPunch to manage their workforce.
          <br />
          Book a free demo and see it in action.
        </p>
        <div className="schedule-demo__actions">
          <Link
            className="schedule-demo__button schedule-demo__button--primary"
            to="/contact_us"
          >
            Book a Demo <span aria-hidden="true">→</span>
          </Link>
          <Link
            className="schedule-demo__button schedule-demo__button--secondary"
            to="/contact_us"
          >
            Talk to Sales
          </Link>
        </div>
      </div>
      <div className="schedule-demo__portrait">
        <img src={portrait} alt="Smiling business professional" />
      </div>
      <div className="schedule-demo__benefits">
        <ul>
          {benefits.map((benefit, index) => (
            <li key={benefit}>
              <span
                className={`schedule-demo__icon schedule-demo__icon--${index}`}
                aria-hidden="true"
              >
                {index === 0 ? "✓" : index === 1 ? "♥" : "↗"}
              </span>
              {benefit}
            </li>
          ))}
        </ul>
        <div className="schedule-demo__note">
          Your People
          <br />
          Our Priority
          <svg viewBox="0 0 110 65" aria-hidden="true">
            <path d="M8 42C42 70 84 48 95 8M82 16L96 7L98 23" />
          </svg>
        </div>
      </div>
    </div>
  </section>
);

export default ScheduleDemo;
